import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-beige pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          {/* Col 1 - Logo & Description */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/9074dcc9d7143784ab7725571df8118f.jpeg"
                alt="Túi trò chơi dân gian Bahnar"
                className="w-12 h-12 object-contain"
              />
              <span className="text-lg font-bold text-primary-brown-dark leading-tight">
                TÚI TRÒ CHƠI<br />DÂN GIAN BAHNAR
              </span>
            </div>
            <p className="text-primary-brown-light text-sm leading-relaxed">
              Nơi trẻ em khám phá và học hỏi văn hóa Bahnar qua những trò chơi dân gian truyền thống đầy ý nghĩa.
            </p>
          </div>

          {/* Col 2 - Contact Info + Social */}
          <div className="md:col-span-4">
            <h3 className="text-base font-bold text-primary-brown-dark mb-5">
              Thông tin liên hệ
            </h3>
            <ul className="space-y-4 mb-6">
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-orange/10 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-primary-orange text-base"></i>
                </div>
                <a
                  href="mailto:websitetrochoidangianbahnar@gmail.com"
                  className="text-sm text-primary-brown-light hover:text-primary-orange transition-colors cursor-pointer break-all"
                >
                  websitetrochoidangianbahnar@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-orange/10 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-primary-orange text-base"></i>
                </div>
                <span className="text-sm text-primary-brown-light">
                  0327 246 230
                </span>
              </li>
            </ul>

            {/* Social Icons */}
            <div>
              <p className="text-sm font-bold text-primary-brown-dark mb-3">Theo dõi chúng tôi</p>
              <div className="flex items-center gap-3">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-orange/10 text-primary-orange hover:bg-primary-orange hover:text-white transition-all cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-base"></i>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-orange/10 text-primary-orange hover:bg-primary-orange hover:text-white transition-all cursor-pointer"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-fill text-base"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-orange/10 text-primary-orange hover:bg-primary-orange hover:text-white transition-all cursor-pointer"
                  aria-label="Zalo"
                >
                  <i className="ri-message-3-fill text-base"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Col 3 - Slogan */}
          <div className="md:col-span-4 flex items-center justify-center">
            <div className="w-full text-center py-4">
              <div className="flex items-center justify-center gap-2 mb-4">
                <i className="ri-star-fill text-primary-orange text-2xl"></i>
                <i className="ri-seedling-fill text-primary-orange text-3xl"></i>
                <i className="ri-star-fill text-primary-orange text-2xl"></i>
              </div>
              <p className="text-primary-brown-dark font-extrabold text-3xl leading-snug tracking-wide mb-2">
                Kết nối văn hóa
              </p>
              <div className="w-16 h-1 bg-primary-orange mx-auto my-3 rounded-full"></div>
              <p className="text-primary-brown font-bold text-xl leading-snug">
                Trao truyền giá trị dân gian
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-6 border-t border-primary-brown-light/20 flex flex-col md:flex-row items-center justify-center gap-2">
          <p className="text-sm text-primary-brown-light text-center">
            © 2026 Túi trò chơi dân gian Bahnar. Bảo lưu mọi quyền.
          </p>
        </div>
      </div>
    </footer>
  );
}
